export default "__VITE_ASSET__D7bpDZ0u__"